import React, { useState, useEffect } from 'react';
import i18next from 'i18next';
import user from 'src/js/modules/user';
import SplitPageView from 'src/js/common/components/split-page-view';
import EmailVerification from '../components/email-verification';

const getCaptions = () => ({
  title: i18next.t('Verify your email'),
  description: i18next.t(
    'We’ve sent a link to your inbox. Please click it to confirm your email address.'
  ),
  cta: i18next.t('Didn’t get email? Check spam or resend below.'),
  button: i18next.t('Resend verification email'),
  errorMessage: i18next.t('Something went wrong. Please try again later.'),
  successMessage: i18next.t('A new verification email has been sent.'),
});

const EmailVerificationContainer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState(null);
  const captions = getCaptions();

  const sendVerificationEmail = (showNotification = true) => {
    setIsLoading(true);

    user.operations
      .sendVerificationEmail()
      .then(() => {
        setIsLoading(false);

        if (showNotification) {
          setNotification({
            appearance: 'success',
            text: captions.successMessage,
          });
        }
      })
      .catch((e) => {
        console.error(e);

        setIsLoading(false);

        if (showNotification) {
          setNotification({
            appearance: 'danger',
            text: captions.errorMessage,
          });
        }
      });
  };

  useEffect(() => {
    sendVerificationEmail(false);
    // eslint-disable-next-line yola/react-hooks/exhaustive-deps
  }, []);

  return (
    <SplitPageView
      images={{
        x1: '/images/login-cover-image@1x.png',
        x2: '/images/login-cover-image@2x.png',
      }}
    >
      <EmailVerification
        captions={captions}
        isLoading={isLoading}
        notification={notification}
        onVerifyEmailClick={sendVerificationEmail}
      />
    </SplitPageView>
  );
};

export default EmailVerificationContainer;
